
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/test-google",
      function () {
        return require("private-next-pages/test-google.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/test-google"])
      });
    }
  